import React, { Component } from 'react';
import PropTypes from 'prop-types';

class GeckoCol extends Component {
  prepareClasses(width) {
    return `col-${width.replace('col-', '')}`;
  }

  renderClasses() {
    return this.props.width
      .split(' ')
      .map((width) => this.prepareClasses(width))
      .join(' ');
  }

  render() {
    return this.props.hideWhen && this.props.hideWhen() ? null : (
      <div className={this.renderClasses()}>{this.props.children}</div>
    );
  }
}

GeckoCol.propTypes = {
  width: PropTypes.string,
  hideWhen: PropTypes.func,
};

GeckoCol.defaultProps = {
  width: '',
};

export default GeckoCol;
